export const environment = {
  production: false,
  maintenance: false,
  backend: {
    baseUrl: "https://be-dev.siram.elvoon.it/approva-ws/api/v1",
  },
  oauth2_redirect_url: "https://be-dev.siram.elvoon.it/oauth2/redirect", 
  googleOauth: {
    clientId: "622187157441-1ro3agc3nkakrmjja8o67bgrq7f7e0cb.apps.googleusercontent.com"
  },
  google: { 
    auth_url:
    "https://be-dev.siram.elvoon.it/approva-ws/api/v1/oauth2/authorize/google?redirect_uri=https://approva-dev.siram.elvoon.it/authentication/oauth2/redirect", // dev siram
    clientId:
      "622187157441-1ad8mu0gv3bsr5ualt8glc24ltqhf6q8.apps.googleusercontent.com",
    appId:'622187157441', // NOT CHANGED
    apikeydrive:'AIzaSyC9hbqh6rtoWmVtaXeUMBK0CNVVZnZctgw', // #gitleaks:allow // NOT CHANGED
    mapkey:'AIzaSyD5x5lo2OTmK_mCG2Mwom-9viEkSSiR7PQ' // #gitleaks:allow // NOT CHANGED
  },
  deleghe: "claudia.vissicchio@demo.noovle.it"
};  
